import { Directive, ElementRef, HostListener } from '@angular/core';
import { NgControl } from '@angular/forms';
import { NgxMaskPipe } from 'ngx-mask';

@Directive({
  selector: '[appCpfCnpjMask][formControlName],[appCpfCnpjMask][formControl],[appCpfCnpjMask][ngModel]',
  providers: [NgxMaskPipe]
})
export class CpfCnpjMaskDirective {

  constructor(private ngControl: NgControl, private elementRef: ElementRef, private maskPipe: NgxMaskPipe) {}

  @HostListener('input', ['$event'])
  onInput(event: string) {
    const value = this.elementRef.nativeElement.value;
    console.log(event);
    if (value.length <= 11) {
      // Formata como CPF
      //this.ngControl.control.setValue(this.maskPipe.transform(value, '000.000.000-00'));
    } else {
      // Formata como CNPJ
     // this.ngControl.control.setValue(this.maskPipe.transform(value, '00.000.000/0000-00'));
    }
  }
  // DICA: no template sera chamado assim, <input type="text" appCpfCnpjMask formControlName="cpfCnpj">
}
